import 'maplibre-gl/dist/maplibre-gl.css';
import './style.css';
import { initMap } from './map';
import { resolveDataSource } from './data/source';
import { addPOILayer } from './layers/poi-layer';

const dataSource = resolveDataSource();
const map = initMap('map');

map.on('load', async () => {
  console.log('Tivano Maps loaded. Source:', import.meta.env.VITE_DATA_SOURCE ?? 'static');
  await addPOILayer(map, dataSource);
  console.log('POI layer added');
});
